import { render } from "./ValidationReceiptContainer.vue?vue&type=template&id=1fbf6434"
import script from "./ValidationReceiptContainer.vue?vue&type=script&lang=js"
export * from "./ValidationReceiptContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__